import { Injectable, Injector } from '@angular/core';
import { HttpEvent, HttpInterceptor, HttpRequest, HttpHandler } from '@angular/common/http'

import { Observable, tap, throwError, BehaviorSubject, filter, take, switchMap, catchError } from 'rxjs';
import Swal from 'sweetalert2';
import { Router } from '@angular/router';
import { SpinnerService } from './shared/spinner.service';
import { NgxSpinnerService } from 'ngx-spinner';
import { AuthenticationService } from './authentication.service';

@Injectable({
  providedIn: 'root'
})
export class TokenInterCepterService implements HttpInterceptor {

  private isRefreshing = false;
  private refreshTokenSubject: BehaviorSubject<string | null> = new BehaviorSubject<string | null>(null);

  constructor(private injector: Injector, private router: Router, private spinner: SpinnerService, private spinner2: NgxSpinnerService) { }

  private get authService(): AuthenticationService {
    return this.injector.get(AuthenticationService);
  }

  intercept(req: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
    // Skip adding auth headers to the refresh endpoint itself
    if (req.url.includes('/auth/refresh')) {
      return next.handle(req);
    }

    const tokenizedReq = this.addToken(req);
    return next.handle(tokenizedReq).pipe(
      tap({
        next: (res: any) => {
          if (res?.body?.data) {
            if (res.body.data === 'Session Expired . Please login again') {
              this.spinner.hide()
              this.spinner2.hide()
              Swal.fire({
                title: `${res.body['data']}`,
                icon: 'warning',
                showCancelButton: false,
                confirmButtonColor: '#3085d6',
                cancelButtonColor: '#d33',
                confirmButtonText: 'Logout!'
              }).then(async (result: any) => {
                if (result.value) {
                  sessionStorage.clear()
                  this.router.navigate(['/login'])
                  window.location.reload()
                }
              })
              throw new Error('SESSION_EXPIRED');
            }
          }
        },
        error: () => {}
      }),
      catchError(err => {
        if (err?.status === 401) {
          return this.handle401Error(tokenizedReq, next);
        }
        return throwError(() => err);
      })
    );
  }

  private addToken(req: HttpRequest<any>): HttpRequest<any> {
    let headers: any = {};
    const token = sessionStorage.getItem('1000');
    const gatewayId = sessionStorage.getItem('1001');
    const accountId = sessionStorage.getItem('1005');

    if (token) headers['1000'] = `bearer ${token}`;
    if (gatewayId) headers['1001'] = `${gatewayId}`;
    if (accountId) headers['1005'] = `${accountId}`;

    return req.clone({
      setHeaders: headers
    });
  }

  private handle401Error(req: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
    const refreshToken = sessionStorage.getItem('_rt');
    if (!refreshToken) {
      this.logout();
      return throwError(() => new Error('No refresh token'));
    }

    if (this.isRefreshing) {
      // Queue concurrent requests while refresh is in progress
      return this.refreshTokenSubject.pipe(
        filter(token => token !== null),
        take(1),
        switchMap(() => next.handle(this.addToken(req)))
      );
    }

    this.isRefreshing = true;
    this.refreshTokenSubject.next(null);

    return this.authService.refreshAccessToken(refreshToken).pipe(
      switchMap((resp: any) => {
        this.isRefreshing = false;
        sessionStorage.setItem('1000', resp.token);
        if (resp.refreshToken) sessionStorage.setItem('_rt', resp.refreshToken);
        this.refreshTokenSubject.next(resp.token);
        return next.handle(this.addToken(req));
      }),
      catchError(err => {
        this.isRefreshing = false;
        this.logout();
        return throwError(() => err);
      })
    );
  }

  private logout(): void {
    sessionStorage.clear();
    this.router.navigate(['/login']);
  }

}
